import type { CallToActionBlockVariant } from "@newxsystems/types";
import { CallToActionSplit } from "../../../../modules/call-to-action/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/call-to-action/components/CallToActionStacked/CallToActionStacked";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";

export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { buttons, description, eyebrow, heading, image } = props;
  const hasVisibleContent = Boolean(eyebrow || heading || description || image || buttons?.length);

  if (!hasVisibleContent) {
    return null;
  }

  const variant: CallToActionBlockVariant = props.variant ?? "stacked";

  return variant === "split" ? (
    <CallToActionSplit {...props} />
  ) : (
    <CallToActionStacked {...props} />
  );
};

CallToActionBlock.displayName = "Block::CallToActionBlock";
